import { BleTagConnectionHistoryDto } from 'api/api';
import actionCreatorFactory from 'typescript-fsa';
import { constants } from './constants';

const actionCreator = actionCreatorFactory('ble-connection-history');

export const GetBleConnectionHistoryAction = actionCreator.async<
	{ serialNumber: string; startDate: Date; endDate: Date },
	BleTagConnectionHistoryDto[]
>(constants.GET_BLE_CONNECTION_HISTORY);
